import React, { Component } from "react";
import Input from "../Forms/Input";
import {
  signOut,
  editUserEvent,
  getFieldOfMedicine,
  getCurrentUser,
  sendEmailVerification,
  checkIFUserExists,
  searchDrFromHealthengine,
  emailAuthProvider,
  getUnreadNotificationCount,
  updateNotificationViewedAt,
  updateProviderAuthEmail,
  checkOperationsPatientOrProviderByEmailExists,
} from "../../../store/actions";
import { Link } from "react-router-dom";
import renderHTML from "react-render-html";
import {
  validateEmail,
  makeid,
  getBool,
  validatePassword,
} from "../../../utils/helperFunctions";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Cookies from "universal-cookie";
import { firebaseAuth, firebaseStorage } from "../../../firebase/firebase";
import Webcam from "react-webcam";
import appConstants from "../../../appConstants";
import version from "../../../build_version";
import responseMessages from "../../../response.json";
import Loader from "../../Loader";
import moment from "moment";
import FieldOfMedicine from "../FieldOfMedicine";
import Select from "react-dropdown-select";
import Collapse from "react-bootstrap/Collapse";
import { compress } from "../../../utils/imageOperations";
import Notifications from "../Notifications";
import ProviderIDManagerView from "../ProviderIDManagerView";
import CalendarIcon from "../../Icon/CalenderIcon";
import AppointmentSetup from "../AppoinmentSchedule/Common/AppointmentSetup";
import { loggerHandleFunction } from "../../../utils/loggerHandleFunction";
import Swal from "sweetalert2";
import ProviderIDManager from "../ProviderIDManager";
// import { Collapse } from "bootstrap";
const cookie = new Cookies();

class Leftbar extends Component {
  constructor(props) {
    super(props);
    let user = cookie.get("user", { path: "/" }) || {};
    let textToSearch = "";
    if (user && user.firstName) textToSearch += user.firstName + " ";
    if (user && user.lastName) textToSearch += user.lastName;

    let showMoreOptions = cookie.get("showMoreOptions", { path: "/" });
    this.state = {
      isLoading: false,
      isFocused: false,
      logoutModal: false,
      profilePictureModal: false,
      profileSetting: false,
      editProfile: false,
      profileMenu: false,
      user,
      defaultImage: "/assets/img/placeholder.png",
      cameraActive: false,
      progress: 0,
      profilePicUrl: user && user.profilePicUrl ? user.profilePicUrl : "",
      firstName: user && user.firstName ? user.firstName : "",
      lastName: user && user.lastName ? user.lastName : "",
      email: user && user.email ? user.email : "",
      phoneNumber: user && user.phoneNumber ? user.phoneNumber : "",
      fieldOfMedicine: user && user.fieldOfMedicine ? user.fieldOfMedicine : "",
      providers: user && user.providers ? user.providers : [],
      appointmentBookingUrl:
        user && user.appointmentBookingUrl ? user.appointmentBookingUrl : "",
      isUserFormValid: false,
      profilePicHover: false,
      showMoreOptions: showMoreOptions ? getBool(showMoreOptions) : true,
      clinicDetail: cookie.get("clinic", { path: "/" }) || {},
      textToSearch: textToSearch,
      resetPasswordModal: false,
      password: "",
      confirmPassword: "",
      currentPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      showCurrentPassword: false,
      passwordFormValid: false,
      errors: {
        password: "",
        confirmPassword: "",
      },
      profileErrors: {},
      showNotifications: false,
      unreadNotificationCount: 0,
    };
    this.logout = this.logout.bind(this);
    this.resetProfileForm = this.resetProfileForm.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.captureImage = this.captureImage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateUserForm = this.validateUserForm.bind(this);
    this.handleUserSubmit = this.handleUserSubmit.bind(this);
    this.handleTooltipNextCalled = this.handleTooltipNextCalled.bind(this);
    this.handleChangeBookingURL = this.handleChangeBookingURL.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.validatePasswordForm = this.validatePasswordForm.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.showHideNotifications = this.showHideNotifications.bind(this);
  }

  componentWillMount() {
    this.handleSearchDrFromHealthengine();
  }

  async componentDidMount() {
    let fieldOfMedicine = await getFieldOfMedicine();
    this.setState({
      fieldOfMedicineOptions: fieldOfMedicine,
    });

    let { user } = this.state;
    getUnreadNotificationCount(
      {
        userId: user.userId || "",
        notificationViewedAt: user.notificationViewedAt || "",
      },
      (err, res) => {
        if (!err) {
          this.setState({
            unreadNotificationCount: res.size,
          });
        } else {
          console.log("[Error getting count]", err);
        }
      }
    );
  }

  showHideNotifications = () => {
    this.setState({
      showNotifications: !this.state.showNotifications,
      unreadNotificationCount: 0,
    });
    let { user } = this.state;
    updateNotificationViewedAt(
      {
        userId: user.userId,
      },
      (err, res) => {
        if (!err) {
          // res.date
          user.notificationViewedAt = res.date;
          cookie.set("user", user, { path: "/" });
        }
      }
    );
  };

  setRef = (webcam) => {
    if (this.state.cameraActive) {
      this.webcam = webcam;
    }
  };

  async handleFileChange(e) {
    let target = e.target;
    let image = target.files[0];
    if (image) {
      this.setState({ isLoading: true });
      let reader = new FileReader();

      reader.onload = async (e) => {
        compress(e.target.result, "jpeg", async (compresedFile, base46) => {
          let newBase = base46;
          newBase = newBase.replace("data:image/jpeg;base64,", "");
          compresedFile.name = image.name;
          image = compresedFile;
          const uploadTask = firebaseStorage
            .ref(`images/${image.name}`)
            .put(image);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              // progress function ...
              const progress = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              this.setState({ progress });
            },
            (error) => {
              //TODO Show Error
              loggerHandleFunction(error.message || responseMessages.DB_ERROR);
              console.log("Error", error);
            },
            () => {
              // complete function ...
              firebaseStorage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then((url) => {
                  this.setState(
                    { profilePicUrl: url, isLoading: false },
                    () => {
                      this.validateUserForm();
                    }
                  );
                });
            }
          );
        });
      };
      reader.readAsDataURL(image);
    }
  }

  async captureImage() {
    this.state.isLoading = true;
    const image = this.webcam.getScreenshot();
    this.setState({ cameraActive: false });
    const name = `${await makeid(
      8,
      appConstants.idChar
    )}-${moment().valueOf()}`;
    const blob = await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        resolve(xhr.response);
      };
      xhr.onerror = function () {
        reject(new TypeError("Network request failed"));
      };
      xhr.responseType = "blob";
      xhr.open("GET", image, true);
      xhr.send(null);
    });

    const uploadTask = firebaseStorage
      .ref(`images/`)
      .child(name)
      .put(blob, { contentType: "image/jpeg" });
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress function ...
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ progress });
      },
      (error) => {
        //TODO Show Error
        loggerHandleFunction(error.message || responseMessages.DB_ERROR);
        console.log("Error", error);
      },
      () => {
        // complete function ...
        firebaseStorage
          .ref("images")
          .child(name)
          .getDownloadURL()
          .then((url) => {
            this.setState({ profilePicUrl: url, isLoading: false });
          });
      }
    );
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState(
      {
        [event.target.name]: value,
      },
      () => {
        this.validateUserForm();
      }
    );
  }

  handleChangePassword(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let errors = this.state.errors;

    switch (name) {
      case "password":
        errors.password =
          value.length === 0 || !validatePassword(value)
            ? "Password must contain atleast 8 Characters including An Upper Case Character, A Digit & A Special Character!"
            : this.state.confirmPassword.length > 0 &&
              value !== this.state.confirmPassword
            ? "Password does not match!"
            : "";
        break;
      case "confirmPassword":
        errors.confirmPassword =
          value.length > 0 &&
          this.state.password.length > 0 &&
          value !== this.state.password
            ? "Password does not match!"
            : "";
        break;
      default:
        break;
    }
    this.setState(
      {
        [event.target.name]: value,
      },
      () => {
        this.validatePasswordForm();
      }
    );
  }

  handleSelectChange(array, selected) {
    this.setState(
      {
        [selected]: array,
      },
      () => {
        this.validateUserForm();
      }
    );
  }

  async handleSearchDrFromHealthengine() {
    try {
      let { textToSearch, lastTextToSearch } = this.state;
      if (textToSearch !== lastTextToSearch) {
        this.setState({ isFectingDr: true });
        let data = await searchDrFromHealthengine({
          search: textToSearch,
        });

        let drToSelectArray = [];
        data &&
          data.data &&
          data.data.practitioner && data.data.practitioner.forEach((prac) => {
            drToSelectArray.push(
              Object.assign(
                {
                  value: data.data ? data.data.baseURL + prac.url : prac.url,
                  label: `${prac.name} ${prac.suburb ? prac.suburb : ""} ${
                    prac.specialty ? prac.specialty : ""
                  }`,
                },
                prac
              )
            );
          });

        let selectedDrArray =
          drToSelectArray.length &&
          drToSelectArray.find(
            (d) => d.value == this.state.appointmentBookingUrl
          )
            ? [
                drToSelectArray.find(
                  (d) => d.value == this.state.appointmentBookingUrl
                ),
              ]
            : [];
        this.setState({
          drToSelectArray,
          selectedDrArray,
          isFectingDr: false,
          lastTextToSearch: textToSearch,
        });
      }
    } catch (err) {
      this.setState({ isFectingDr: false });
      console.log("[Error]", err);
    }
  }

  handleChangeBookingURL(selectedValues, methods) {
    // let appointmentBookingUrl = "";
    // if (selectedValues) appointmentBookingUrl = selectedValues[0].value;

    // selectedValues = selectedValues.map((e) => {
    //   return {
    //     label: e.value,
    //     value: e.value,
    //   };
    // });
    // this.setState(
    //   {
    //     selectedDrArray: selectedValues,
    //     appointmentBookingUrl,
    //   },
    //   () => {
    //     this.validateUserForm();
    //   }
    // );
    let appointmentBookingUrl = "";
    let selectedDrArray = [];
    if (selectedValues) {
      appointmentBookingUrl = selectedValues.value;
      selectedDrArray.push(selectedValues);
    }

    this.setState(
      {
        selectedDrArray: selectedDrArray,
        appointmentBookingUrl,
      },
      () => {
        if (
          methods &&
          methods.dropDown &&
          typeof methods.dropDown === "function"
        ) {
          methods.dropDown("close");
        }
      }
    );
  }

  validateUserForm() {
    let {
      firstName,
      lastName,
      phoneNumber,
      email,
      fieldOfMedicine,
      appointmentBookingUrl,
    } = this.state;

    if (
      firstName &&
      lastName &&
      phoneNumber &&
      email &&
      validateEmail(email) &&
      fieldOfMedicine &&
      appointmentBookingUrl
    ) {
      this.setState({
        isUserFormValid: true,
      });
    } else {
      this.setState({
        isUserFormValid: false,
      });
    }
  }

  logout() {
    this.setState({ logoutModal: false });
    // signOut(this.props.isAdmin, this.props.history.push());
    signOut(this.props?.isAdmin, () => {
      this.props.history.push("/login"); // Redirect to the login page
    });
    
  }

  resetProfileForm() {
    this.setState({ editProfile: false });
  }

  async handleUserSubmit() {
    debugger
    try {
      let {
        firstName,
        lastName,
        phoneNumber,
        email,
        fieldOfMedicine,
        appointmentBookingUrl,
        profilePicUrl,
        // isUserFormValid,
        user,
        clinicDetail,
        providers
      } = this.state;

      // if (!isUserFormValid) {
      //   return false;
      // }

      if (email !== user.email) {
        let userRef = await getCurrentUser();
        if (userRef.uid === user.userId) {
          let userExists = await checkIFUserExists(
            email,
            phoneNumber,
            user.userId
          );
          let authUserExists = await checkOperationsPatientOrProviderByEmailExists(email);
          if (userExists.length === 0 && !authUserExists) {
            const response = await updateProviderAuthEmail(user.userId, email);
            if (response.success) {
              await sendEmailVerification(
                email,
                `${firstName} ${lastName}`,
                `${clinicDetail.clinicName}`,
                () => {}
              );

              await this.updateUserData({
                firstName,
                lastName,
                phoneNumber,
                email,
                fieldOfMedicine,
                appointmentBookingUrl,
                profilePicUrl,
                user,
                providers: providers || [], 
              });

              await Swal.fire({
                icon: 'success',
                title: 'Email Updated',
                text: 'Your email has been changed successfully. Please verify your email and login again.',
                confirmButtonText: 'OK',
              });
    
              // Log out the user
              await firebaseAuth.signOut();
    
              loggerHandleFunction('Email and user data updated successfully');
            } else {
              loggerHandleFunction(response.error);
            }
            // userRef.updateEmail(email).then(
            //   async () => {
            //     await sendEmailVerification(
            //       email,
            //       `${firstName} ${lastName}`,
            //       `${clinicDetail.clinicName}`,
            //       () => {}
            //     );
            //     // await userRef.sendEmailVerification();
            //     // await updatePatientEmail(user.userId, email);
            //     this.updateUserData({
            //       firstName,
            //       lastName,
            //       phoneNumber,
            //       email,
            //       fieldOfMedicine,
            //       appointmentBookingUrl,
            //       profilePicUrl,
            //       user,
            //       providers: providers || [],
            //     });
            //   },
            //   (error) => {
            //     console.log("error:", error);
            //     let message =
            //       error.message || responseMessages.EMAIL_UPDATE_ERROR;
            //     loggerHandleFunction(message);
            //   }
            // );
          } else {
            Swal.fire({
              text: "User with this Email / Phone already Exists!",
              icon: "error"
            });
            loggerHandleFunction("User with this Email / Phone already Exists!");
          }
        } else {
          loggerHandleFunction(responseMessages.USER_ERROR);
        }
      } else {
        this.updateUserData({
          firstName,
          lastName,
          phoneNumber,
          email,
          fieldOfMedicine,
          appointmentBookingUrl,
          profilePicUrl,
          user,
          providers: providers || [],
        });
      }
    } catch (err) {
      //TODO Show Error
      loggerHandleFunction(err.message || responseMessages.DB_ERROR);
      console.log("Error", err);
    }
  }

  async updateUserData(data) {
    let metaData = {
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      email: data.email,
      fieldOfMedicine: data.fieldOfMedicine,
      appointmentBookingUrl: data.appointmentBookingUrl,
      profilePicUrl: data.profilePicUrl,
    };

    if(data.providers) {
      metaData = {
        ...metaData,
        providers: data.providers
      }
    }
    
    let eventId = await editUserEvent(data.user.userId, metaData);
    
    if (eventId) {
      data.user = { ...data.user, ...metaData };
      this.setState({ user: data.user });
      cookie.set("user", data.user || {}, { path: "/" });
      this.setState({
        clinicDetail: cookie.get("clinic", { path: "/" }) || {},
      });
    }
  }

  handleMouseChange(field, value) {
    this.setState({
      [field]: value,
    });
  }

  handleTooltipNextCalled(event) {
    event.preventDefault();
    if (this.props.handleToolTipNext) {
      this.props.handleToolTipNext();
    }
  }

  validatePasswordForm() {
    let { password, confirmPassword, currentPassword } = this.state;

    if (
      currentPassword &&
      password &&
      validatePassword(password) &&
      confirmPassword &&
      validatePassword(confirmPassword) &&
      password === confirmPassword
    ) {
      this.setState({
        passwordFormValid: true,
      });
    } else {
      this.setState({
        passwordFormValid: false,
      });
    }
  }

  showHidePassword(stateToUpdate, e) {
    e.preventDefault();
    this.setState({
      [stateToUpdate]: !this.state[stateToUpdate],
    });
  }

  async resetPassword() {
    let { currentPassword, password } = this.state;
    this.reauthenticate(currentPassword)
      .then(() => {
        var user = getCurrentUser();
        user
          .updatePassword(password)
          .then(() => {
            loggerHandleFunction(responseMessages.PASSWORD_UPDATE_SUCCESS);
            this.setState({
              resetPasswordModal: false,
              password: "",
              currentPassword: "",
              confirmPassword: "",
            });
          })
          .catch((error) => {
            let message = (error && error.message) || responseMessages.DB_ERROR;
            loggerHandleFunction(message);
            this.setState({
              resetPasswordModal: false,
              password: "",
              currentPassword: "",
              confirmPassword: "",
            });
          });
      })
      .catch((error) => {
        let message = (error && error.message) || responseMessages.DB_ERROR;
        loggerHandleFunction(message);
        this.setState({
          resetPasswordModal: false,
          password: "",
          currentPassword: "",
          confirmPassword: "",
        });
      });
  }

  reauthenticate = (currentPassword) => {
    var user = getCurrentUser();
    var cred = emailAuthProvider(user.email, currentPassword);
    return user.reauthenticateWithCredential(cred);
  };

  renderErrorMessage(type) {
    let { errors } = this.state;
    if (errors[type]) {
      return renderHTML(
        `<div className="error-wrapper"><p className="error-message">${errors[type]}</p></div>`
      );
    }
    return "";
  }

  render() {
    let {
      logoutModal,
      profilePictureModal,
      profileSetting,
      editProfile,
      profileMenu,
      user,
      defaultImage,
      cameraActive,
      profilePicUrl,
      firstName,
      lastName,
      email,
      phoneNumber,
      showMoreOptions,
      appointmentBookingUrl,
      selectedDrArray,
      drToSelectArray,
      resetPasswordModal,
      password,
      confirmPassword,
      currentPassword,
      showConfirmPassword,
      showPassword,
      showCurrentPassword,
      passwordFormValid,
      showNotifications,
      unreadNotificationCount,
    } = this.state;

    return (
      <div>
        {this.state.isLoading ? (
          <div className="custm-loader">
            <Loader></Loader>
          </div>
        ) : null}
        {/* Menu for mobile view */}
        <div className="mobile-menu">
          <div className="dashboard-logo">
            <Link to="/dashboard">
              <img
                src="/assets/img/dashboard-logo.png"
                alt="logo"
                className="img img-fluid"
              />
            </Link>
          </div>
          {this.props.isAdmin ? <div className="admin-tag">Admin</div> : <></>}
          <div className="leftbar-bottom">
            <ul>
              <li>
                <Link
                  to={this.props.isAdmin ? "/admin/patients" : "/dashboard"}
                  className={`patients-menu d-flex ${
                    [
                      "care_plan",
                      "user_dashboard",
                      "add_care_plan",
                      "admin_patient_list",
                      "admin_single_patient_progress",
                      "admin_single_patient_careplan",
                      "admin_single_patient_documents",
                      "admin_single_patient_health_notes",
                    ].includes(this.props.activeId)
                      ? "menu-active"
                      : ""
                  }`}
                >
                  <span>
                    <img src="/assets/img/users.png" alt="" />
                    <img
                      alt=""
                      className="menu-white"
                      src="/assets/img/users-white.png"
                    />
                  </span>{" "}
                  Patients
                </Link>
              </li>
              <li>
                <Link
                  to={this.props.isAdmin ? "/admin/clinics" : "/clinicdetail"}
                  className={`patients-menu d-flex ${
                    [
                      "admin_clinic_list",
                      "clinic_details",
                      "admin_clinic_details",
                    ].includes(this.props.activeId)
                      ? "menu-active"
                      : ""
                  }`}
                >
                  <span>
                    <img src="/assets/img/home.png" alt="home" />
                    <img
                      alt="menu_white"
                      className="menu-white"
                      src="/assets/img/home-white.png"
                    />
                  </span>{" "}
                  {this.props.isAdmin ? "Clinics" : "Clinic"}
                </Link>
              </li>
            </ul>

            {profileMenu ? (
              <div className="prfile-setting-menu document-cursor">
                <span className="mobile-menu-arrow"></span>
                <a
                  onClick={() => {
                    this.setState({
                      profileSetting: !this.state.profileSetting,
                      profileMenu: false,
                    });
                    if (profileSetting) {
                      this.resetProfileForm();
                    }
                  }}
                  className={`profile-set ${
                    profileSetting ? "profile-set-active" : ""
                  }`}
                >
                  <img src="/assets/img/setting-icon.png" alt="setting-iocn" />
                  <img
                    alt="setting_active"
                    className="setting-active"
                    src="/assets/img/setting-orange.png"
                  />{" "}
                  Profile
                </a>
                <a
                  onClick={() => {
                    this.setState({ logoutModal: true, profileMenu: false });
                  }}
                  className="logout-btn"
                >
                  <img src="/assets/img/logout-icon.png" alt="log_out" /> Logout
                </a>
              </div>
            ) : (
              ""
            )}
            {!this.props.isAdmin ? (
              <div
                className="account-menu raduis-img profile"
                onClick={() => {
                  this.setState({ profileMenu: !profileMenu });
                }}
              >
                <img src={user.profilePicUrl || defaultImage} alt="" />
              </div>
            ) : null}

            <div
              className="toggle-menu"
              onClick={() => {
                this.setState({ profileMenu: !profileMenu });
              }}
            >
              <a href="">
                <i className="fas fa-bars"></i>
              </a>
            </div>
          </div>
        </div>
        {/* Menu for mobile view ends */}
        <div className="leftbar-menu">
          <div className="dashboard-logo">
            <Link to="/dashboard">
              <img
                alt="logo"
                src="/assets/img/dashboard-logo.png"
                className="img img-fluid"
              />
            </Link>
          </div>
          <div className="dashboard-logo">
            {unreadNotificationCount ? (
              <div className="badges-brand">{unreadNotificationCount}</div>
            ) : null}
            <img
              alt="bell_icon"
              src="/assets/img/Bell_icon.png"
              className="img img-fluid hand-cursor"
              heigh="35"
              width="35"
              onClick={this.showHideNotifications}
            />
          </div>
          {/* {!this.props.isAdmin ? <div className="dashboard-logo">
            <Link to="/appointment">
              <CalendarIcon width={32} height={32} color="#121d55"/>
            </Link>
          </div>
          :
          <></>} */}
          {this.props.isAdmin ? <div className="admin-tag">
            Admin
          </div> : <></>}
          <div className="leftbar-bottom">
            <ul>
              <li>
                <Link
                  to={this.props.isAdmin ? "/admin/patients" : "/dashboard"}
                  className={`patients-menu ${
                    [
                      "care_plan",
                      "user_dashboard",
                      "add_care_plan",
                      "admin_patient_list",
                      "admin_single_patient_progress",
                      "admin_single_patient_careplan",
                      "admin_single_patient_documents",
                      "admin_single_patient_health_notes",
                    ].includes(this.props.activeId)
                      ? "menu-active"
                      : ""
                  }`}
                >
                  <span className="">
                    <img src="/assets/img/users.png" alt="" />
                    <img
                      alt=""
                      className="menu-white"
                      src="/assets/img/users-white.png"
                    />
                  </span>{" "}
                  Patients
                </Link>
              </li>
              <li>
                <Link
                  to={this.props.isAdmin ? "/admin/clinics" : "/clinicdetail"}
                  className={`patients-menu ${
                    [
                      "admin_clinic_list",
                      "clinic_details",
                      "admin_clinic_details",
                    ].includes(this.props.activeId)
                      ? "menu-active"
                      : ""
                  }`}
                >
                  <span>
                    <img src="/assets/img/home.png" alt="home" />
                    <img
                      alt="menu_white"
                      className="menu-white"
                      src="/assets/img/home-white.png"
                    />
                  </span>{" "}
                  {this.props.isAdmin ? "Clinics" : "Clinic"}
                </Link>
              </li>
            </ul>
            {!this.props.isAdmin ? (
              <Collapse in={showMoreOptions}>
                <div className="prfile-setting-menu">
                  <a
                    onClick={() => {
                      this.setState({
                        profileSetting: !this.state.profileSetting,
                      });
                      if (profileSetting) {
                        this.resetProfileForm();
                      }
                    }}
                    className={`profile-set ${
                      profileSetting ? "profile-set-active" : ""
                    }`}
                    aria-controls={`user-profile-settings`}
                    aria-expanded={profileSetting}
                  >
                    <OverlayTrigger
                      key={"settings"}
                      placement={"right"}
                      overlay={
                        <Tooltip id={`settings-tooltip`}>Settings</Tooltip>
                      }
                    >
                      <img
                        src="/assets/img/setting-icon.png"
                        alt="setting-icon"
                      />
                    </OverlayTrigger>
                    <img
                      alt="setting-icon"
                      className="setting-active"
                      src="/assets/img/setting-orange.png"
                    />
                  </a>
                  <a
                    onClick={() => {
                      this.setState({ logoutModal: true });
                    }}
                    className="logout-btn"
                  >
                    <OverlayTrigger
                      key={"logout"}
                      placement={"right"}
                      overlay={<Tooltip id={`logout-tooltip`}>Logout</Tooltip>}
                    >
                      <img src="/assets/img/logout-icon.png" alt="log-out" />
                    </OverlayTrigger>
                  </a>
                </div>
              </Collapse>
            ) : (
              <div className="prfile-setting-menu">
                <span
                  className="logout-btn admin-logout-btn"
                  onClick={() => {
                    this.setState({ logoutModal: true });
                  }}
                >
                  <OverlayTrigger
                    key={"logout"}
                    placement={"right"}
                    overlay={<Tooltip id={`logout-tooltip`}>Logout</Tooltip>}
                  >
                    <img src="/assets/img/logout-icon.png" alt="log-out" />
                  </OverlayTrigger>
                </span>
              </div>
            )}

            <Notifications
              showNotifications={showNotifications}
              showHideNotifications={this.showHideNotifications}
            ></Notifications>

            {!this.props.isAdmin ? (
              <div className="account-menu raduis-img profile">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState(
                      {
                        showMoreOptions: !this.state.showMoreOptions,
                      },
                      () => {
                        cookie.set(
                          "showMoreOptions",
                          this.state.showMoreOptions,
                          { path: "/" }
                        );
                      }
                    );
                  }}
                >
                  <img
                    alt="profile_img"
                    src={user.profilePicUrl || defaultImage}
                  />
                </a>
              </div>
            ) : null}
            {this.props.showToolTip ? (
              <div className="left-tooltip-ab">
                <div className="main-relative">
                  <div className="tootlip-hover tooltip-shadow">
                    <div className="Quick-d-flex">
                      <h1 className="text-white">Quick Tips</h1>
                      <a
                        href=""
                        className="text-white"
                        onClick={this.handleMouseChange.bind(
                          this,
                          "profilePicHover",
                          false
                        )}
                      >
                        <i className="fa fa-times"></i>
                      </a>
                    </div>
                    <div className="line-section">
                      <div className="light-line"></div>
                      <div className="bold-line"></div>
                    </div>

                    <div className="add-p-section">
                      <div className="add-p">
                        <h3 className="text-white">Access Settings</h3>
                        <p>
                          You can access your personal settings and logout by
                          selecting your profile picture.
                        </p>
                      </div>
                      <div
                        className="next-bg bg-white text-center p-2 hand-cursor"
                        onClick={this.handleTooltipNextCalled}
                      >
                        <a href="#">Next</a>
                      </div>
                    </div>
                  </div>
                  <div className="triangle-up left-tootlip"></div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {/* {profileSetting ? ( */}
        <Collapse in={profileSetting} dimension="width">
          <div
            className={`profile-seting-area ${
              editProfile ? "profile-seting-edit" : ""
            }`}
            id="user-profile-settings"
            style={{ position: "fixed" }}
          >
            <div
              className="profile-close"
              onClick={() => {
                this.setState({ profileSetting: false });
                this.resetProfileForm();
              }}
              aria-controls={`user-profile-settings`}
              aria-expanded={profileSetting}
            >
              <img src="/assets/img/exit.png" alt="exit" />
            </div>
            <div className="profile-info">
              <div className="profile-img">
                <div className="profile-img-area raduis-img">
                  <img
                    src={profilePicUrl || defaultImage}
                    className="img img-fluid"
                    alt="profile_img"
                  />
                  {editProfile ? (
                    <button
                      className="change-img btn"
                      style={{
                        color: "#fff",
                        fontSize: "12px",
                        textDecoration: "underline",
                      }}
                      onClick={() => {
                        console.log("rnter");
                        this.setState({
                          profilePictureModal: true,
                          cameraActive: false,
                        });
                      }}
                    >
                      Change
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                {!editProfile ? (
                  <div
                    className="dashboard-head-btn px-2"
                    // style={{
                    //   color: "#fa7a00",
                    //   fontSize: "12px",
                    //   textDecoration: "underline",
                    // }}
                    onClick={() => {
                      this.setState({ editProfile: true });
                      this.validateUserForm();
                    }}
                  >
                    <a>
                      Edit Settings
                    </a>
                    
                  </div>
                ) : (
                  ""
                )}
                {!editProfile ? (
                  <div
                    onClick={() => {
                      this.setState({ resetPasswordModal: true });
                    }}
                  >
                    <button
                      className="btn edit-profile-btn dashboard-head-btn"
                      style={{
                        color: "#fa7a00",
                        fontSize: "12px",
                        textDecoration: "underline",
                        marginTop:'5px'
                      }}
                    >
                      Reset Password
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {editProfile ? (
                  <button
                    disabled={!firstName || !lastName || !email || !phoneNumber}
                    className="dashboard-head-btn"
                    style={{
                      color: "#fa7a00",
                      fontSize: "12px",
                      textDecoration: "underline",
                      padding: '0px',
                      border: 'none'
                    }}
                    onClick={() => {
                      this.setState({
                        editProfile: false,
                        profilePictureModal: false,
                      });
                      this.handleUserSubmit();
                    }}
                  >
                    <a>Save Settings</a>
                  </button>
                ) : (
                  ""
                )}
              </div>
              {!editProfile ? (
                <div className="profile-name-area">
                  <h2>
                    {user.firstName} {user.lastName}
                  </h2>
                  <p>{user.fieldOfMedicine}</p>
                </div>
              ) : (
                ""
              )}
              <div className="profile-detail-area">
                {editProfile ? (
                  <div className="profile-name-edit">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            style={{ color: firstName === "" ? "red" : "" }}
                          >
                            {firstName === ""
                              ? "Requierd FirstName"
                              : "First Name"}
                          </label>
                          <input
                            title="First Name*"
                            type="text"
                            className="form-control"
                            placeholder="First Name*"
                            name="firstName"
                            value={firstName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>
                            <label
                              style={{ color: lastName === "" ? "red" : "" }}
                            >
                              {lastName === ""
                                ? "Requierd LastName"
                                : "Last Name"}
                            </label>
                          </label>
                          <input
                            title="Last Name*"
                            type="text"
                            className="form-control"
                            placeholder="Last Name*"
                            name="lastName"
                            value={lastName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="form-group">
                          {/* <label
                            style={{
                              color: user?.fieldOfMedicine === "" ? "red" : "",
                            }}
                          >
                            {user?.fieldOfMedicine === ""
                              ? "Requierd Medicine"
                              : "Field Of Medicine"}
                          </label> */}

                          {user.fieldOfMedicine}

                          <FieldOfMedicine
                            selectFieldOfMedicine={(fieldOfMedicine) => {
                              this.setState(
                                {
                                  fieldOfMedicine: fieldOfMedicine,
                                },
                                () => this.validateUserForm()
                              );
                            }}
                            className="fieldOfMedicineSignup "
                            selectedValue={user.fieldOfMedicine}
                            showLabel={false}
                          ></FieldOfMedicine>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="form-group">
                  <label
                    style={{
                      color: email === "" ? "red" : "",
                    }}
                  >
                    {email === "" ? "Requierd Email" : "Email Address"}
                  </label>
                  {!editProfile ? (
                    <p>{user.email}</p>
                  ) : (
                    <input
                      title="Email Address*"
                      type="email"
                      className="form-control"
                      placeholder="Email Address*"
                      name="email"
                      value={email}
                      onChange={this.handleChange}
                    />
                  )}
                </div>
                <div className="form-group">
                  <label
                    style={{
                      color: phoneNumber === "" ? "red" : "",
                    }}
                  >
                    {phoneNumber === "" ? "Requierd Phone" : "Phone Number"}
                  </label>
                  {!editProfile ? (
                    <p>
                      <a href={`tel:${user.phoneNumber}`}>{user.phoneNumber}</a>
                    </p>
                  ) : (
                    <input
                      title="Phone Number*"
                      type="text"
                      className="form-control"
                      placeholder="Phone Number*"
                      name="phoneNumber"
                      value={phoneNumber}
                      onChange={this.handleChange}
                    />
                  )}
                </div>
                {editProfile ? 
                  <ProviderIDManager providers={this.state.providers}
                    onProviderChange={(newProviders) => {
                      this.setState({ providers: newProviders });
                    }}
                  />
                  :
                  <></>
                }
                {this.props.isAdmin ? <></> : <AppointmentSetup />}
                {!editProfile ? 
                <>
                {user.providers ? <ProviderIDManagerView providers={user.providers} removeProvider={() => {}} showActionColumn={false}/> : <></>}
                </>
                : <></>}
                
                
              </div>
            </div>
            <div className="versionText">
              {process.env.REACT_APP_HOST_ENV === "production" ? (
                <p>PROD {version.productionVersion}</p>
              ) : (
                <p>UAT {version.uatVersion}</p>
              )}
            </div>
          </div>
        </Collapse>
        <div
          className={`common-popup logout-pop popup-common-class fade ${
            logoutModal ? "show" : ""
          }`}
        >
          <div className="common-popup-outer">
            <div className="common-popup-inner">
              <div className="complete-condition-box animate-box">
                <div className="complete-pop-head">
                  <h3>Log Out?</h3>
                  <div
                    className="common-pop-close"
                    onClick={() => {
                      this.setState({ logoutModal: false });
                    }}
                  >
                    <span className="close-complete-pop">
                      <img src="/assets/img/exit.png" alt="exit" />
                    </span>
                  </div>
                </div>
                <div className="complete-pop-con">
                  <p>Are you sure you want to log out?</p>
                  <div className="complete-pop-btn">
                    <Link
                      to="/login"
                      className="btn red-transparent"
                      onClick={this.logout}
                    >
                      Log Out
                    </Link>
                    <button
                      className="btn blue-btn close-common-pop"
                      onClick={() => {
                        this.setState({ logoutModal: false });
                      }}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.cameraActive ? (
          <div className={`camera-capture popup-common-class`}>
            <div className="camera-capture-inner">
              <a href="#">
                <img
                  alt="exit"
                  src="/assets/img/exit.png"
                  className="img img-fluid"
                  onClick={() => {
                    this.setState({
                      cameraActive: false,
                    });
                  }}
                />
              </a>
              <Webcam
                audio={false}
                ref={this.setRef}
                screenshotFormat="image/jpeg"
              />
              <button onClick={this.captureImage}>Capture photo</button>
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          className={`step-wrapper common-pop update-profile-pop popup-common-class fade ${
            profilePictureModal ? "show" : ""
          }`}
        >
          {this.state.isLoading ? (
            <div className="custm-loader">
              <Loader />
            </div>
          ) : null}
          <div className="patient-pop-outer">
            <div className="patient-pop-box animate-box">
              <div className="step-outter">
                <div className="three-steps">
                  <div className="step-top">
                    <div className="step-progress">
                      <div className="step-p-text">
                        <h4>Update Profile picture</h4>
                        <div
                          className="pop-close-cross"
                          onClick={() => {
                            this.setState({ profilePictureModal: false });
                          }}
                        >
                          <img src="/assets/img/exit.png" alt="exit" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="step-bottom">
                    <div className="step-1 ">
                      <div className="placeholder-image">
                        <img
                          src={profilePicUrl || defaultImage}
                          alt="profile_img"
                          className="img img-fluid"
                        />
                      </div>
                      <div className="step-form">
                        <div className="input-div open">
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control custom-input add-image"
                            onChange={this.handleFileChange}
                          />
                          <div className="dummy-field custom-input">
                            Upload From Gallery
                          </div>
                          <a href="#">
                            <img
                              alt="eye"
                              src="/assets/img/add.png"
                              className="img img-fluid eye"
                            />
                          </a>
                        </div>
                        <div
                          className="input-div open"
                          onClick={() => {
                            this.setState({
                              cameraActive: !this.state.cameraActive,
                            });
                          }}
                        >
                          <input
                            type="text"
                            className="form-control custom-input add-image"
                          />
                          <div className="dummy-field custom-input">
                            Take Photo on Webcam
                          </div>
                          <a href="#">
                            <img
                              alt="eye"
                              src="/assets/img/camera.png"
                              className="img img-fluid eye"
                            />
                          </a>
                        </div>
                      </div>
                      <div className="input-div">
                        <button
                          className="log-btn step-btn"
                          onClick={() => {
                            this.setState({
                              profilePicUrl: profilePicUrl,
                              profilePictureModal: false,
                            });
                          }}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`add-patent-pop add-patient-pop-background popup-common-class fade ${
            resetPasswordModal ? "show" : ""
          }`}
        >
          <div className="patient-pop-outer">
            <div className="patient-pop-box animate-box">
              <div className="step-outter">
                <div className="three-steps">
                  <div className="step-top">
                    <div className="step-progress">
                      <div className="step-p-text">
                        <h4>Change Password</h4>
                        <div
                          className="pop-close-cross"
                          onClick={() => {
                            this.setState({ resetPasswordModal: false });
                          }}
                        >
                          <img src="/assets/img/exit.png" alt="exit" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="step-bottom">
                    <div className="step-3 ">
                      <div className="step-2-form">
                        <div className="row">
                          <div className="col-lg-12">
                            <Input
                              title="Current Password*"
                              type={showCurrentPassword ? "text" : "password"}
                              className="form-control custom-input"
                              placeholder="Current Password*"
                              name="currentPassword"
                              value={currentPassword}
                              onChange={this.handleChangePassword}
                            >
                              <a
                                tabIndex="-1"
                                href="#"
                                onClick={this.showHidePassword.bind(
                                  this,
                                  "showCurrentPassword"
                                )}
                              >
                                <img
                                  alt="eye"
                                  src="/assets/img/eye.png"
                                  className="img img-fluid eye"
                                />
                              </a>
                            </Input>
                            {this.renderErrorMessage("currentPassword")}
                          </div>
                          <div className="col-lg-12">
                            <Input
                              title="New Password*"
                              type={showPassword ? "text" : "password"}
                              className="form-control custom-input"
                              placeholder="New Password*"
                              name="password"
                              value={password}
                              onChange={this.handleChangePassword}
                            >
                              <a
                                tabIndex="-1"
                                href="#"
                                onClick={this.showHidePassword.bind(
                                  this,
                                  "showPassword"
                                )}
                              >
                                <img
                                  alt="eye"
                                  src="/assets/img/eye.png"
                                  className="img img-fluid eye"
                                />
                              </a>
                            </Input>
                            {this.renderErrorMessage("password")}
                          </div>
                          <div className="col-lg-12">
                            <Input
                              title="Confirm New Password*"
                              type={showConfirmPassword ? "text" : "password"}
                              className="form-control custom-input"
                              placeholder="Confirm New Password*"
                              name="confirmPassword"
                              value={confirmPassword}
                              onChange={this.handleChangePassword}
                            >
                              <a
                                tabIndex="-1"
                                href="#"
                                onClick={this.showHidePassword.bind(
                                  this,
                                  "showConfirmPassword"
                                )}
                              >
                                <img
                                  alt="eye"
                                  src="/assets/img/eye.png"
                                  className="img img-fluid eye"
                                />
                              </a>
                            </Input>
                            {this.renderErrorMessage("confirmPassword")}
                          </div>
                          <div className="col-lg-12 password-error-field">
                            Password does not match. Try Again.
                          </div>
                        </div>
                      </div>
                      <div className="input-div">
                        <button
                          disabled={!passwordFormValid}
                          className={`log-btn step-btn ${
                            passwordFormValid ? "" : "disable-btn"
                          }`}
                          onClick={this.resetPassword}
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Leftbar;
